import React from 'react'

import {MenuLink} from '@src/modules/Layout/shared/MenuLink'
import {SCHEDULING_ROUTES} from '../../constants'
import {Badge, Icon} from '@therms/atalaya'
import {useRPCServerEventHandler} from '@therms/react-modules'
import {useCurrentShiftsCounts} from '@src/modules/Scheduling/hooks/useCurrentShiftsCounts'
import {FaCalendarAlt} from 'react-icons/fa'

function SchedulingMenuLink() {
  const {counts, refresh} = useCurrentShiftsCounts({
    includeUnassignedShifts: true,
  })

  useRPCServerEventHandler('CurrentShiftsUpdated', refresh)

  return (
    <MenuLink to={SCHEDULING_ROUTES.__ROOT__}>
      <div className="flex flex-col">
        <div className="gap-x-sm inline-flex items-center">
          <Icon Icon={FaCalendarAlt} size="sm" />

          <div className="flex align-middle">Schedule</div>
        </div>

        <div className="ml-xl mt-xs">
          <div className="gap-y-xxs flex flex-col text-xs">
            {!!counts.notstarted?.total && (
              <div className="gap-x-xxs inline-flex">
                <Badge
                  value={counts.notstarted?.total}
                  color={counts.notstarted?.color}
                />

                <span style={{color: counts.notstarted?.color}}>
                  Not Started
                </span>
              </div>
            )}

            {!!counts.notended?.total && (
              <div className="gap-x-xxs inline-flex">
                <Badge
                  value={counts.notended?.total}
                  color={counts.notended?.color}
                />

                <span style={{color: counts.notended?.color}}>Not Ended</span>
              </div>
            )}

            {!!counts.onbreak?.total && (
              <div className="gap-x-xxs inline-flex">
                <Badge
                  value={counts.onbreak?.total}
                  color={counts.onbreak?.color}
                />

                <span style={{color: counts.onbreak?.color}}>On Break</span>
              </div>
            )}

            {!!counts.inprogress?.total && (
              <div className="gap-x-xxs inline-flex">
                <Badge
                  value={counts.inprogress?.total}
                  color={counts.inprogress?.color}
                />

                <span style={{color: counts.inprogress?.color}}>
                  In Progress
                </span>
              </div>
            )}

            {!!counts.ended?.total && (
              <div className="gap-x-xxs inline-flex">
                <Badge
                  value={counts.ended?.total}
                  color={counts.ended?.color}
                />

                <span style={{color: counts.ended?.color}}>Ended</span>
              </div>
            )}
          </div>
        </div>
      </div>
    </MenuLink>
  )
}

export {SchedulingMenuLink}
